<template>
<div>
  <v-breadcrumbs>
      <v-breadcrumbs-item to="/secure/teachers">Teachers</v-breadcrumbs-item>
      <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
      <v-breadcrumbs-item :disabled="true">
        New
      </v-breadcrumbs-item>
    </v-breadcrumbs>
  <teacher-form :centers="myCenters" @submit="saveTeacher" />
</div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import {mask} from 'vue-the-mask'
import {rules} from "@/store/util/rules.js";
import TeacherForm from '@/components/teacher/NewTeacherForm.vue';
import { createTeacher } from "@/services/teacher.js";

export default {
  components: {
    TeacherForm
  },
  props: {
    dialog: { type: Boolean, default: false },
  },
  data() {
    return {
      // centers: [],
      center: null,
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      about: "",
      rules
    };
  },
  directives: {mask},
  computed: {
    ...mapGetters(["navState", "isAppLoading", "myCenters"]),
    dialogState: {
      get() {
        return this.dialog;
      },
      set(val) {
        this.$emit("updateDialog", val);
      },
    },
  },
  mounted() {
    // this.loadCenters();
  },
  methods: {
    ...mapActions(["hideDialog", "addErrorMessage"]),
    saveTeacher(teacher) {
      createTeacher(teacher).then((resp) => {
          console.log(resp.data.data);
          const savedTeacher = resp.data.data;

          this.$router.push({name: 'Teacher', params: {id: savedTeacher.id}})
        })
        .catch((error) => {
          this.addErrorMessage(error.message);
        });
    },
    // loadCenters() {
    //   this.$axios.get("/center/get-my-centers").then((resp) => {
    //     // console.log(resp.data);
    //     this.centers = resp.data;
    //   });
    // },
  },
};
</script>

<style>
</style>